import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const ObjectTypeRepository = RepositoryFactory.get('InfrastructureRepository')['ObjectTypeRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get } = DefaultStoreActions(ObjectTypeRepository)

export const STORE_MODULE_NAME = 'object_type';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
    },
}
